import React from "react";
import * as S from "./style";

function Input(props: any): React.ReactElement {
  const inputRef = React.useRef<any>(null);
  const chose = () => {
    if (inputRef.current) {
      inputRef.current!.focus({
        cursor: "all",
      });
    }
  };
  return (
    <S.InputCustom>
      <input
        {...props}
        ref={inputRef}
        onClick={chose}
        type="text"
      />
    </S.InputCustom>
  );
}

export default Input;
